const StoreManager = require("../storeManager")

const debounce = require("../../helpers/debounce.js")

module.exports = function (socket, store, initState) {

  // create the manager
  let manager = new StoreManager({
    createWorker: globalThis.createWorker,
    readIndex() {
      return this.nextIndex || store.getState().state
    },

    writeIndex(next) {
      this.nextIndex = next
      store.dispatch({
        type: 'SET_STATE',
        state: next
      })
    },

    updateAllStore({
      toFetch,
      toClean
    }) {
      if (Object.keys(toClean).length) {
        store.dispatch({
          type: "DELETE_ALL_ELEMENTS",
          toClean
        })
      }
      if (toFetch.length) {
        Promise.all(toFetch.map(e => Promise.all(Object.entries(e).map(([type, uids]) => {
          return socket.call({
            action: "select",
            params: { type, uids }
          })
            .then(elements => ({ type, elements }))
            .catch((err) => {
              console.log(`error fetching ${type}`, toFetch)
              console.error(err);
            })
        })))).then(array => store.dispatch({
          type: 'UPDATE_ALL_ELEMENTS',
          elements: array.flat()
        }))
      }
    },

    onStart(index) {

      // Listen to updates
      if (!socket.listeners("newState").includes(this.onNewState)) {
        socket.on("newState", this.onNewState)
      }
      if (!socket.listeners("notification").includes(this.onNotif)) {
        socket.on("notification", this.onNotif)
      }

      // Initialize the manager
      this.updateAll(index)
    },

    onClose() {
      socket.removeListener("newState", this.onNewState)
      socket.removeListener("notification", this.onNotif)
    }
  })

  manager.onNewState = debounce(function (state) {
    this.updateAll(state)
  }, 250, true, manager)

  manager.onNotif = (notif) => {
    store.dispatch({
      type: "PUSH_NOTIFICATION",
      notif
    })
  }

  manager.start(initState)

  return manager
}